import { adminHttpClient } from '../../commons/adminHttpClient'

export type EmployeeEligibilityInfoResponse = {
  isEligible: boolean
  benefitEligibilityDate?: Date
  terminationDate?: Date
  productClassId?: string
}

export const getPerksEmployeeEligibilityInfo = (planPeriodId: string): Promise<EmployeeEligibilityInfoResponse> => {
  return adminHttpClient.get(`/EEDashboard/Perks/GetPerksEmployeeEligibilityInfo/${planPeriodId}`, {})
}
